var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5352 18.506C13.3842 15.596 15.4042 12.749 17.2662 9.84602C17.4512 9.55902 17.5722 9.20302 17.6982 8.75602C17.6982 8.75602 19.3072 3.09402 19.3442 2.99002C19.8042 1.70702 20.5722 1.29802 21.8522 1.61702C22.7122 1.83302 23.4442 2.32602 24.0292 3.08402C24.8522 4.15102 25.1512 5.35602 25.3202 6.28702C25.6432 8.07902 25.5302 9.94802 24.9642 12.169C24.5882 13.637 23.4992 17.5 23.4992 17.5H29.4352C30.8772 17.503 32.1972 18.061 33.1512 19.069C34.0882 20.06 34.5632 21.377 34.4882 22.778C34.4542 23.409 34.2982 23.988 34.1592 24.5C34.1592 24.5 32.4322 31.256 31.5942 34.495C30.6652 38.082 27.4922 40.513 23.8842 40.513C23.6292 40.513 23.3712 40.501 23.1122 40.476C22.6082 40.428 16.4682 39.118 11.6932 38.083",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 39.5H4.5C2.843 39.5 1.5 38.157 1.5 36.5V20.5C1.5 18.843 2.843 17.5 4.5 17.5H11.5V36.5C11.5 38.157 10.157 39.5 8.5 39.5Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.9d4d9b26c914202ffc3b6902c3be6769.svg";
export { ForwardRef as ReactComponent };